import { useState, useCallback } from 'react';

export const usePointerLock = (controlsRef) => {
    const [isLocked, setIsLocked] = useState(false);

    const handleLock = useCallback(() => {
        // Don't lock if clicking UI elements
        const activeElement = document.activeElement;
        const isUIElement = activeElement && (
            activeElement.closest('.side-menu-overlay') ||
            activeElement.closest('.right-menu-overlay') ||
            activeElement.closest('.menu-content') ||
            activeElement.closest('.modal') ||
            activeElement.closest('.control-bar') ||
            activeElement.closest('.wallet-button') ||
            activeElement.closest('.edit-mode') ||
            activeElement.closest('.examine-mode')
        );

        if (isUIElement) {
            controlsRef.current?.unlock();
            setIsLocked(false);
            return;
        }

        setIsLocked(true);
        controlsRef.current?.movementSystem?.enable();
    }, [controlsRef]);

    const handleUnlock = useCallback(() => {
        setIsLocked(false);
        controlsRef.current?.movementSystem?.disable();
    }, [controlsRef]);

    const forceUnlock = useCallback(() => {
        controlsRef.current?.unlock();
        setIsLocked(false);
        controlsRef.current?.movementSystem?.disable();
    }, [controlsRef]);

    return {
        isLocked,
        handleLock,
        handleUnlock,
        forceUnlock
    };
}; 